import { IAttribute, IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from './linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.odbc.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Odbc_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Odbc_DisplayText)
    ]
})
export class OdbcLinkedService extends LinkedService {
    public static readonly MODEL: IModel;
    public static readonly CONNECTION_STRING: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly PASSOWRD: IAttribute;
    public static readonly CREDENTIAL: IAttribute;


    @Metamodel.attribute({
        display: stringResources.ModelName_ConnectionString,
        association: 'CONNECTION_STRING',
        templatable: true,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        accepts: ['String']
    })
    public connectionString?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        association: 'PASSOWRD',
        templatable: true,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        accepts: ['String']
    })
    public password?: string | AzureKeyVault; // TODO: need a secure type to make sure this won't be exposed to customer.

    @Metamodel.attribute({
        display: stringResources.ModelName_Credential,
        association: 'CREDENTIAL',
        templatable: true,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        accepts: ['String']
    })
    public credential?: string | AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
